import { useState } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { Menu } from '../../Menu/index.js'
import { IconButton } from '../../IconButton/index.js'
import { $getSelection, ParagraphNode } from 'lexical'
import { HeadingNode } from '@lexical/rich-text'
import { $setBlocksType } from '@lexical/selection'

export const SelectTextStyle = ({ nodeType, disabled, size }) => {
  const [editor] = useLexicalComposerContext()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <Menu onOpen={() => setMenuOpen(true)} onClose={() => setMenuOpen(false)}>
      <Menu.Trigger>
        <IconButton
          tooltip={menuOpen ? null : 'Select text style'}
          size={size}
          icon="text-styling"
          trailChevron="down"
          disabled={disabled}
        />
      </Menu.Trigger>
      <Menu.Items>
        <Menu.ToggleItem
          visualOnlyKeyHint="Cmd+Alt+0"
          toggled={nodeType === 'paragraph'}
          value={nodeType === 'paragraph'}
          onChange={() => {
            editor.update(() => {
              const selection = $getSelection()
              $setBlocksType(selection, () => new ParagraphNode())
            })
          }}
        >
          Paragraph
        </Menu.ToggleItem>
        <Menu.ToggleItem
          toggled={nodeType === 'heading-h1'}
          value={nodeType === 'heading-h1'}
          visualOnlyKeyHint="Cmd+Alt+1"
          onChange={() => {
            editor.update(() => {
              const selection = $getSelection()
              $setBlocksType(selection, () => new HeadingNode('h1'))
            })
          }}
        >
          Heading 1
        </Menu.ToggleItem>
        <Menu.ToggleItem
          visualOnlyKeyHint="Cmd+Alt+2"
          toggled={nodeType === 'heading-h2'}
          value={nodeType === 'heading-h2'}
          onChange={() => {
            editor.update(() => {
              const selection = $getSelection()
              $setBlocksType(selection, () => new HeadingNode('h2'))
            })
          }}
        >
          Heading 2
        </Menu.ToggleItem>
        <Menu.ToggleItem
          visualOnlyKeyHint="Cmd+Alt+3"
          toggled={nodeType === 'heading-h3'}
          value={nodeType === 'heading-h3'}
          onChange={() => {
            editor.update(() => {
              const selection = $getSelection()
              $setBlocksType(selection, () => new HeadingNode('h3'))
            })
          }}
        >
          Heading 3
        </Menu.ToggleItem>
      </Menu.Items>
    </Menu>
  )
}
